import React, {Component} from "react"
import "./components/custom/custom_style.css"
import ApiHelper from "src/ApiHelper"
import axios from "axios"
import Recommendations from "./containers/Recommendations"
import {withRouter} from "react-router-dom"
import RecommendationCard from "src/components/cards/RecommendationCard"

class Home extends Component{
    constructor(props){
        super(props)
        this.state = {
            searchkey: "",
            searchresults: [],
            noofcompanies : null,
            searchid: 0,
            searchresultsloading: false
        }
    }
    showSearchResults(){
        var rows = []
        for(var i = 0; i < this.state.searchresults.length; i++){
            rows.push(<RecommendationCard key={this.state.searchresults[i].serialid} noofcompanies={this.state.noofcompanies} recommendation={this.state.searchresults[i]}/>)
        }
        return rows
    }
    render(){
        return <div className="c_container">
                <div className="c_banner_container">
                    <div className="c_banner_content">
                        <p className="c_search_intro_text">
                            Search in a database of over {this.state.noofcompanies} companies. Recommendations for stocks are updated every day
                        </p>
                        <input className="c_stock_input" placeholder="Tata Communications Limited, Hero Mo..." value={this.state.searchkey} onChange={this.onSearchKeyChanged.bind(this)}/>
                    </div>
                </div>
                <div className="c_search_results">{this.state.searchresultsloading?<h4>Loading...</h4>: ""}{this.showSearchResults()}</div>
                {/* <MarketIndexes/> */}
                <Recommendations noofcompanies={this.state.noofcompanies}/>
            </div>
    }
    onSearchKeyChanged(event){
        const newstate = {...this.state}
        newstate.searchkey = event.target.value
        newstate.searchid += 1
        newstate.searchresultsloading = event.target.value.length > 0? true:false
        this.setState(newstate, () => {
            this.searchCompanies()
        })
    }
    searchCompanies(){
        console.log(this.state.searchkey)
        var search = axios.post(ApiHelper.companies.getArthSortedCompaniesBySearchKey, {searchid: this.state.searchid, searchkey: this.state.searchkey})
        search.then(response => {
            const newstate = {...this.state}
            if(this.state.searchkey.length > 0 && response.data.searchid === this.state.searchid){
                newstate.searchresults = response.data.data
            }
            newstate.searchresultsloading = false
            this.setState(newstate)
    }, error => {
            const newstate = {...this.state}
            newstate.searchresults = []
            this.setState(newstate)
        })
    }
    componentDidMount(){
        this.getNumberOfCompanies()
        this.doSomething()
    }
    doSomething(){
        var x = Math.round(Math.random() * 3)
        switch(x){
            case 1: 
                console.log("updating recommendations")
                this.refreshRecommendations()
                break
            case 2: 
                console.log("updating symbols")
                this.updateRecommendationSymbols()
                break
            case 3: 
                console.log("updating orders")
                this.updateOrders()
                break
            default: 
                console.log("updating orders")
                this.updateOrders()
                break
        }
    }
    refreshRecommendations(){
        var refresh = axios.post(ApiHelper.brokerRecos.refreshRecommendations)
        refresh.then(response => {
            console.log("Recommendations Refreshed")
        }, error => {
            console.log("Recommendations Not Refreshed")
        })
    }
    updateRecommendationSymbols(){
        var updatesymbols = axios.post(ApiHelper.brokerRecos.updateRecommendationSymbols)
        updatesymbols.then(response => {
            console.log("Symbols Updated")
        }, error => {
            console.log("Symbols Not Updated")
        })
    }
    updateOrders(){
        var updateorders = axios.post(ApiHelper.brokerRecos.updateOrders)
        updateorders.then(response => {
            console.log("Orders Updated")
        }, error => {
            console.log("Orders Not Updated")
        })
    }
    
    getNumberOfCompanies(){
        var noofcompanies = axios.post(ApiHelper.companies.getNumberOfCompanies)
        noofcompanies.then((data) => {
            const newstate = {...this.state}
            // console.log(data)
            newstate.noofcompanies = data.data.data
            this.setState(newstate)
        }, (error) => {
            // console.log(error)
        })
    }
    componentDidUpdate(){

    }
}

export default withRouter(Home)